
var uikit = require('arrow.uikit');
module.exports = uikit;
module.exports.default = uikit;



// WEBPACK FOOTER //
// ./assets/uikit.js